import React from 'react';
import { useTranslation } from 'react-i18next';

import { sheetForMonth } from 'loot-core/src/shared/months';
import * as monthUtils from 'loot-core/src/shared/months';

import { ExpenseTotal } from '../budget/tracking/budgetsummary/ExpenseTotal';
import { IncomeTotal } from '../budget/tracking/budgetsummary/IncomeTotal';
import { Saved } from '../budget/tracking/budgetsummary/Saved';
import { Modal, ModalCloseButton, ModalHeader } from '../ui/modal';
import { Stack } from '../common/Stack';
import { NamespaceContext } from '../spreadsheet/NamespaceContext';

type TrackingBudgetSummaryModalProps = {
  month: string;
};

export function TrackingBudgetSummaryModal({
  month,
}: TrackingBudgetSummaryModalProps) {
  const { t } = useTranslation();
  const currentMonth = monthUtils.currentMonth();
  return (
    <Modal name="tracking-budget-summary">
      {({ state: { close } }) => (
        <>
          <ModalHeader
            title={t('Budget Summary')}
            rightContent={<ModalCloseButton onClick={close} />}
          />
          <NamespaceContext.Provider value={sheetForMonth(month)}>
            <Stack
              spacing={2}
              style={{
                alignSelf: 'center',
                backgroundColor: 'transparent',
                borderRadius: 4,
              }}
            >
              <IncomeTotal style={{ fontSize: 15, fontWeight: 500 }} />
              <ExpenseTotal style={{ fontSize: 15, fontWeight: 500 }} />
            </Stack>
            <Saved
              projected={month >= currentMonth}
              style={{ fontSize: 15, fontWeight: 500, marginTop: 20 }}
            />
          </NamespaceContext.Provider>
        </>
      )}
    </Modal>
  );
}
